import { axiosInstance } from '~/common/utils/api.util';

import type { ApiResponse } from '~/common/types/api.type';
import type { User } from '~/features/user/types/user.type';

/**
 * 사용자 상세 조회
 * @description 특정 사용자의 상세 정보를 조회합니다
 * @endpoint GET /admin/users/{id}
 * @param id - 사용자 ID
 * @returns 사용자 상세 정보
 */
export function getUserApi(id: number) {
  return axiosInstance.get<ApiResponse<User>>(`/admin/users/${id}`);
}
